module.exports = __webpack_public_path__ + "static/media/paypal.b40eb305.svg";